/**
 * Created by olga on 24.01.2024
 */

const ChainSaleWindow = Prefab.createWindow("chain_sale", "chainsalewindow_prefab_json");
